import { Component, OnInit } from '@angular/core';
import { VehicleService } from '../../../../../core/services/impl/section-services/vehicle-model/vehicle.service';

@Component({
  selector: 'app-collected-car',
  templateUrl: './collected-cars.component.html',
  styleUrls: ['./collected-cars.component.scss']
})
export class CollectedCarsComponent implements OnInit {

  readonly translationsContainer = 'VEHICLE_MODEL_SECTION.COLLECTED_CARS_COMPONENT';

  constructor(private vehicleService: VehicleService) {
  }

  ngOnInit() {
    if (!this.amount) {
      this.vehicleService.collectedCars.amount = 0;
    }
  }

  get isAmountEstimated(): boolean {
    return this.vehicleService.collectedCars.isAmountEstimated;
  }

  get amount(): number {
    return this.vehicleService.collectedCars.amount;
  }

  get collectedCarsAmountLabel() {
    return this.isAmountEstimated ? `>${this.amount}` : this.amount;
  }

  get vehiclesString(): string {
    if (this.amount === 1) {
      return this.getFullTranslationKey('vehicleSuffix1');
    }
    return this.getFullTranslationKey('vehicleSuffix2');
  }

  private getFullTranslationKey(subKey: string): string {
    return `${this.translationsContainer}.${subKey}`;
  }

}
